import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import {
    showTeamLoader,
    onSaveTeam,
    onTeamClose,
} from 'actions/team';
import { inputFields, displayedImage, showErrors, modalHeader, isFormValid, getFormError } from '../common';

const TeamAdd = () => {
    const dispatch = useDispatch();
    const addTeamState = useSelector(state => state.teams.addTeamState);
    const [selectedTeam, setSelectedTeam] = useState(initProps);
    const [formErrors, setFormErrors] = useState({ name: '' });
    const [formValid, setFormValid] = useState(false);

    useEffect(() => {
        setSelectedTeam(initProps());
    }, [addTeamState]);

    // using selectedTeam makes it behave like componentDidUpdate - effect takes place when selectedTeam changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
    }, [selectedTeam]);

    const initProps = () => {
        return {
            id: '',
            orgid: '',
            name: '',
            description: '',
            starred: false,
            frequently: false,
        };
    };

    const handleUserInput = (event, isNumber) => {
        const name = event.target.name;
        let value = event.target.value;
        if (isNumber) {
            value = Number(event.target.value);
        }
        updateSelectedTeamField(name, value);
        validateField(name, value);
    };

    const updateSelectedTeamField = (fieldName, value) => {
        const newTeam = { ...selectedTeam };
        newTeam[fieldName] = value;
        setSelectedTeam(newTeam);
    };

    const validateField = (fieldName, value) => {
        formErrors[fieldName] = getFormError(fieldName, value);
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        setFormValid(isFormValid(selectedTeam));
    };


    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showTeamLoader());
                dispatch(onTeamClose());
                dispatch(onSaveTeam(selectedTeam));
                setSelectedTeam(initProps());
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onTeamClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedTeam)}
                        {showErrors(formErrors)}
                        {inputFields(selectedTeam, handleUserInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };
    
    return (
        <Modal className="modal-box" isOpen={addTeamState}>
            {modalHeader(<IntlMessages id="team.addTeam" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="team.addTeam" />)}
        </Modal>
    );
};

export default TeamAdd;


// WEBPACK FOOTER //
// ./components/Agile/team/teamMaintenance/teamAdd/index.js